import { FC, useState } from 'react';
import { Button, ConfigProvider, Space, Tooltip, theme, Badge } from 'antd';
import { CloudDownloadOutlined } from '@ant-design/icons';
import { useRecoilValue } from 'recoil';
import { uiThemeAtom } from 'packages/at-shell/state/recoil/ui';
import { useAtomValue } from 'jotai';
import { selectedResultsAtom } from 'packages/omnitag/state';
import { ProfileMenuButton } from 'packages/polaris/profile-menu-button';
import { DataRequestDialog } from 'packages/polaris/tool/data-request-dialog';
import { WelcomeTour } from 'packages/polaris/tool/welcome-tour';
import { useTourRef } from 'packages/omnitag/hooks/use-tour-refs';

/** Buttons shown in the top-right of the nav bar  */
export const PolarisTopUI: FC<React.PropsWithChildren<unknown>> = () => {
  const uiTheme = useRecoilValue(uiThemeAtom);
  const selectedResults = useAtomValue(selectedResultsAtom);
  const [isRequestDialogOpen, setIsRequestDialogOpen] = useState(false);
  const profileButtonRef = useTourRef<HTMLButtonElement>('profile-button');
  const dataDownloadRef = useTourRef<HTMLButtonElement>('data-download');

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
      }}
    >
      <div style={{ marginRight: '1em' }}>
        <div style={{ height: '100%' }}>
          <div>
            <Space>
              <Badge
                count={selectedResults.size}
                overflowCount={999}
                style={{ zIndex: 1 }}
              >
                <Tooltip title="Gathers and triggers all CAN info from the selected data.">
                  <Button
                    icon={<CloudDownloadOutlined />}
                    disabled={selectedResults.size === 0}
                    onClick={() => setIsRequestDialogOpen(true)}
                    ref={dataDownloadRef}
                  >
                    Request Selected Data
                  </Button>
                </Tooltip>
              </Badge>
              <WelcomeTour />
              <ConfigProvider
                theme={{
                  algorithm:
                    uiTheme === 'dark'
                      ? theme.darkAlgorithm
                      : theme.defaultAlgorithm,
                }}
              >
                <ProfileMenuButton
                  enableThemeToggle
                  buttonRef={profileButtonRef}
                />
              </ConfigProvider>
            </Space>
          </div>
        </div>
      </div>
      <DataRequestDialog
        open={isRequestDialogOpen}
        onClose={() => setIsRequestDialogOpen(false)}
      />
    </ConfigProvider>
  );
};
